export default {
  namespaced: true,
  bau_complement: {
    title: "BAU Complement",
    cctv_tracking: "CCTV Tracking",
    property_visits: "Property Visits",
    list_title: "BAU Complements",
    new: "New BAU Complement",
    reference_number: "Reference Number",
    select_form: "Select forms",
    select_form_place_holder: "Select a form",
    selected_form: "Selected form",
    answer_form: "Start form",
    start_form: "Start form",
    confirm_delete: "Are you sure you want to delete this BAU complement?",
    no_records: "No BAU complements found",
    reassign: "Reassign",
    confirm_cancel: "Are you sure you want to cancel this BAU complement?",
    canceled: "BAU complement canceled",
    edit_form_answers: "Edit form answers",
    related_forms: "Related forms",
    property: "Property",
    one_required_field_missing: "1 required field is missing",
    multiple_required_fields_missing: "Required fields are missing",
  },
};
